import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=8da74a1a&scoped=true&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"
import style0 from "./BoxList.vue?vue&type=style&index=0&id=8da74a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da74a1a",
  null
  
)

export default component.exports